import _get from "lodash/get";
import { getNwData } from '../utils';
import { EXTRA_CONTENT_LABELS, getExtraContentScore, getExtraContentContent } from '../utils/review/legacy';
/**
 * Get alternate picks for a Review.
 *
 * @param   {Object} review     WordPress Review
 * @return  {Array}             array of supplied alternate picks
 */

export var getAlternatePicks = function getAlternatePicks(review) {
  return _get(getNwData(review), 'alternate_picks');
};
/**
 * Get the "cons" bullets for a Review.
 *
 * @param   {Object} review     WordPress Review
 * @return  {Array}             The "cons" array
 */

export var getConsBullets = function getConsBullets(review) {
  return _get(getNwData(review), 'cons');
};
/**
 * Get the "pros" bullets for a Review.
 *
 * @param   {Object} review     WordPress Review
 * @return  {Array}             The "pros" array
 */

export var getProsBullets = function getProsBullets(review) {
  return _get(getNwData(review), 'pros');
};
/**
 * Get Review star rating.
 *
 * @param   {Object} review     WordPress Review
 * @return  {number}            review rating
 */

export var getStarRating = function getStarRating(review) {
  return _get(getNwData(review), 'rating');
};
/**
 * Get Review summary.
 *
 * @param   {Object} review     WordPress Review
 * @return  {Object}            The review summary (structured content).
 */

export var getSummary = function getSummary(post) {
  return _get(post, 'content.structured');
};
/**
 * Get Review synopsis.
 *
 * @param   {Object} review     WordPress Review.
 * @return  {string}            Review synopsis.
 */

export var getSynopsis = function getSynopsis(review) {
  return _get(getNwData(review), 'synopsis');
};
/** Legacy selectors for `banking-products` service fields below */

/**
 * Get the legacy "cons" bullets for a Review.
 * @deprecated
 *
 * @param   {Object} review     WordPress Review
 * @return  {Array}             The legacy "cons" array
 */

export var getLegacyConsBullets = function getLegacyConsBullets(review) {
  return _get(review, 'nw_review_content.cons');
};
/**
 * Get the legacy "pros" bullets for a Review.
 * @deprecated
 *
 * @param   {Object} review     WordPress Review
 * @return  {Array}             The legacy "pros" array
 */

export var getLegacyProsBullets = function getLegacyProsBullets(review) {
  return _get(review, 'nw_review_content.pros');
};
/**
 * Get legacy rating for bank experience.
 * @deprecated
 *
 * @param {Object} post - The legacy WordPress review post object.
 * @returns {Number} - The rating for bank experience.
 */

export var getStarRatingBankExperience = function getStarRatingBankExperience(post) {
  return getExtraContentScore(post, EXTRA_CONTENT_LABELS.BANK_EXPERIENCE);
};
/**
 * Get legacy rating for overdraft fees.
 * @deprecated
 *
 * @param {Object} post - The legacy WordPress review post object.
 * @returns {Number} - The rating for bank experience.
 */

export var getStarRatingOverdraftFee = function getStarRatingOverdraftFee(post) {
  return getExtraContentScore(post, EXTRA_CONTENT_LABELS.OVERDRAFT_FEE);
};
/**
 * Get legacy HTML Review summary.
 * @deprecated
 *
 * @param   {Object} review     WordPress Review
 * @return  {String}            The review summary (HTML).
 */

export var getSummaryHtml = function getSummaryHtml(post) {
  return _get(post, 'content.rendered');
};
/**
 * Get legacy review for bank experience.
 * @deprecated
 *
 * @param {Object} post - The legacy WordPress review post object.
 * @returns {Number} - The summary for bank experience.
 */

export var getSummaryBankExperience = function getSummaryBankExperience(post) {
  return getExtraContentContent(post, EXTRA_CONTENT_LABELS.BANK_EXPERIENCE);
};
/**
 * Get legacy review for overdraft fees.
 * @deprecated
 *
 * @param {Object} post - The legacy WordPress review post object.
 * @returns {Number} - The summary for overdraft fees.
 */

export var getSummaryOverdraftFee = function getSummaryOverdraftFee(post) {
  return getExtraContentContent(post, EXTRA_CONTENT_LABELS.OVERDRAFT_FEE);
};